/*eslint-disable */
import WarningsModal from './WarningsModal';

export default WarningsModal;
